/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterBlockContentAddPost } from '../fn/block-content/api-master-block-content-add-post';
import { ApiMasterBlockContentAddPost$Params } from '../fn/block-content/api-master-block-content-add-post';
import { apiMasterBlockContentDeleteGet } from '../fn/block-content/api-master-block-content-delete-get';
import { ApiMasterBlockContentDeleteGet$Params } from '../fn/block-content/api-master-block-content-delete-get';
import { apiMasterBlockContentEditPost } from '../fn/block-content/api-master-block-content-edit-post';
import { ApiMasterBlockContentEditPost$Params } from '../fn/block-content/api-master-block-content-edit-post';
import { apiMasterBlockContentGetActiveGet } from '../fn/block-content/api-master-block-content-get-active-get';
import { ApiMasterBlockContentGetActiveGet$Params } from '../fn/block-content/api-master-block-content-get-active-get';
import { apiMasterBlockContentGetAllGet } from '../fn/block-content/api-master-block-content-get-all-get';
import { ApiMasterBlockContentGetAllGet$Params } from '../fn/block-content/api-master-block-content-get-all-get';
import { apiMasterBlockContentGetByCriteriaPost } from '../fn/block-content/api-master-block-content-get-by-criteria-post';
import { ApiMasterBlockContentGetByCriteriaPost$Params } from '../fn/block-content/api-master-block-content-get-by-criteria-post';
import { apiMasterBlockContentGetByIdGet } from '../fn/block-content/api-master-block-content-get-by-id-get';
import { ApiMasterBlockContentGetByIdGet$Params } from '../fn/block-content/api-master-block-content-get-by-id-get';
import { BlockContent } from '../models/block-content';
import { BlockContentApiRespModel } from '../models/block-content-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class BlockContentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterBlockContentAddPost()` */
  static readonly ApiMasterBlockContentAddPostPath = '/api/Master/BlockContent/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentAddPost$Response(params?: ApiMasterBlockContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockContentApiRespModel>> {
    return apiMasterBlockContentAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentAddPost(params?: ApiMasterBlockContentAddPost$Params, context?: HttpContext): Observable<BlockContentApiRespModel> {
    return this.apiMasterBlockContentAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BlockContentApiRespModel>): BlockContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentEditPost()` */
  static readonly ApiMasterBlockContentEditPostPath = '/api/Master/BlockContent/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentEditPost$Response(params?: ApiMasterBlockContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockContentApiRespModel>> {
    return apiMasterBlockContentEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentEditPost(params?: ApiMasterBlockContentEditPost$Params, context?: HttpContext): Observable<BlockContentApiRespModel> {
    return this.apiMasterBlockContentEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<BlockContentApiRespModel>): BlockContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentDeleteGet()` */
  static readonly ApiMasterBlockContentDeleteGetPath = '/api/Master/BlockContent/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentDeleteGet$Response(params?: ApiMasterBlockContentDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterBlockContentDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentDeleteGet(params?: ApiMasterBlockContentDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterBlockContentDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentGetByIdGet()` */
  static readonly ApiMasterBlockContentGetByIdGetPath = '/api/Master/BlockContent/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetByIdGet$Response(params?: ApiMasterBlockContentGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<BlockContent>> {
    return apiMasterBlockContentGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetByIdGet(params?: ApiMasterBlockContentGetByIdGet$Params, context?: HttpContext): Observable<BlockContent> {
    return this.apiMasterBlockContentGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<BlockContent>): BlockContent => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentGetAllGet()` */
  static readonly ApiMasterBlockContentGetAllGetPath = '/api/Master/BlockContent/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetAllGet$Response(params?: ApiMasterBlockContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
    return apiMasterBlockContentGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetAllGet(params?: ApiMasterBlockContentGetAllGet$Params, context?: HttpContext): Observable<Array<BlockContent>> {
    return this.apiMasterBlockContentGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BlockContent>>): Array<BlockContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentGetActiveGet()` */
  static readonly ApiMasterBlockContentGetActiveGetPath = '/api/Master/BlockContent/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetActiveGet$Response(params?: ApiMasterBlockContentGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
    return apiMasterBlockContentGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterBlockContentGetActiveGet(params?: ApiMasterBlockContentGetActiveGet$Params, context?: HttpContext): Observable<Array<BlockContent>> {
    return this.apiMasterBlockContentGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BlockContent>>): Array<BlockContent> => r.body)
    );
  }

  /** Path part for operation `apiMasterBlockContentGetByCriteriaPost()` */
  static readonly ApiMasterBlockContentGetByCriteriaPostPath = '/api/Master/BlockContent/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterBlockContentGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentGetByCriteriaPost$Response(params?: ApiMasterBlockContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
    return apiMasterBlockContentGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterBlockContentGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterBlockContentGetByCriteriaPost(params?: ApiMasterBlockContentGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<BlockContent>> {
    return this.apiMasterBlockContentGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BlockContent>>): Array<BlockContent> => r.body)
    );
  }

}
